import { render } from "./RiplayTable.vue?vue&type=template&id=62c0e7a1&scoped=true"
import script from "./RiplayTable.vue?vue&type=script&lang=js"
export * from "./RiplayTable.vue?vue&type=script&lang=js"

import "./RiplayTable.vue?vue&type=style&index=0&id=62c0e7a1&scoped=true&lang=css"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c0e7a1"]])

export default __exports__